document.addEventListener("DOMContentLoaded", function () {
  /* --------------- Get result id -------------------*/
  const getTestResultId = () => {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/");

    // Find the index of 'result' in the path segments
    const resultIndex = pathSegments.indexOf("result");
    const resultId = pathSegments[resultIndex + 1];
    return resultId;
  };

  /* ---------------  Get test results -------------------*/
  const fetchTestResult = async () => {
    try {
      const resultId = getTestResultId(); // Replace with your function to get the test result ID

      if (!userId) {
        throw new Error("Customer not logged in");
      }

      const apiUrl = `${backend_url}/shopify/test-results?user_id=${userId}&id=${encodeURIComponent(resultId)}`;

      const response = await fetch(apiUrl, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const { data, testDetails } = (await response.json()) || [];

      console.log("Test result fetched:", data);

      return { data, testDetails };
    } catch (error) {
      console.error("Error fetching test result:", error);
      return null;
    }
  };

  function mapTestResultsToHTML(data, testDetails) {
    /* ----------------------- gp review container ------------------------------*/
    // Create and append the main container
    var container = $("<div>").addClass("reports-container result-wrapper");
    $("#order-date").text(data.created_at).css({
      margin: "0",
      fontWeight: "bold",
    });
    $(".page-content p").css({
      margin: 0,
    });
    $(".page-content h2").css({
      margin: 0,
      "margin-bottom": "8px",
    });
    $(".page-content").css({
      "margin-bottom": "8px",
      "margin-top": "3rem",
    });
    $("#order-customer-name").text(data.customer_name).css({
      margin: "0",
      fontWeight: "bold",
      "text-transform": "uppercase",
    });
    $("#order-customer-name-p").text(data.customer_name).css({
      margin: "0",
    });

    $("#order-date-p").text(data.created_at).css({
      margin: "0",
    });

    if (data.doctor_feedback) {
      const gp_review = data.doctor_feedback;
      const status = data.status;
      // Create and append the title with image
      var title = $("<h3>").addClass("result-title");
      var image = $("<img>")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/file.svg?v=1700320081",
        )
        .attr("alt", "file icon");
      title.append(image).append("Doctor Review");
      container.append(title);

      // Create and append the flex container
      var gpReviewContainer = $("<div>").addClass(
        "d-flex flex-row h-full w-full doctor-review-container",
      );
      container.append(
        $("<div>").addClass("h-full w-full").append(gpReviewContainer),
      );

      // Create and append the doctor image container
      var docImageContainer = $("<div>").addClass("doc-image-container");
      let doctorimage =
        data?.doctor_details?.image ||
        "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/doctor.png?v=1703168632";
      var docImage = $("<img>")
        .addClass("doc-img")
        .attr("src", doctorimage)
        .attr("alt", "doctor img");
      docImageContainer.append(docImage);
      gpReviewContainer.append(docImageContainer);

      // Create and append the doctor review

      var docReview = $("<div>").addClass("doc-review");
      var docReviewParent = $("<div>").addClass("doctor-review-parent");
      var paragraph = $("<p>").html(gp_review);
      var feedback = $("<p>").text(status).addClass("feedback-badge");
      const reviewDetailsContainer = $("<div>").css({
        width: "100%",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
      });
      docReview.append(docReviewParent);
      docReviewParent.append(paragraph);
      docReviewParent.append(feedback);
      reviewDetailsContainer.append(docReview);
      gpReviewContainer.append(reviewDetailsContainer);
      container.append(gpReviewContainer);
    }
    if (data.footer_content) {
      $("#footer-injector").html(data.footer_content);
    } else {
      const footerHtml = `
          <div class="footer-title">Book an online GP appointment to discuss your test results</div>
          <div class="font-15px">Speak to a fully qualified GP and discuss your results from wherever you are, same day appointments available within a few hours</div>
          <div class="font-weight-600">£58.65 per 20 minute appointment.</div>
        `;
      $("#footer-injector").html(footerHtml);
    }

    if (data.footer_content_url) {
      $("#footer-learn-more a").attr("href", data.footer_content_url);
    }

    if (!data?.switch_off_feedback_footer) {
      $(".footer-container").css({ display: "block" });
    }

    /* ----------------------- gp review container end ------------------------------*/

    var $ul = $("<ul></ul>").addClass("accordion-list");

    var $h3 = $("<h3></h3>").addClass("result-title");
    var $img = $("<img>")
      .attr({
        src: "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/file.svg?v=1700320081",
        alt: "file icon",
      })
      .appendTo($h3);
    $("<span></span>").text(` ${data.name}`).appendTo($h3);

    const processElement = (element, liContainer) => {
      const [testInformation] =
        element["Test Code, Test Name, IT Source, Lab Section"];
      const testPocket = testDetails.find(
        (t) => t.test_code === testInformation,
      );
      const referenceRange = element["Reference Range"];
      const observationValue = handleValue(element["Observation Value"]);

      var values = generateGaugeArray(referenceRange, observationValue);
      // Add three gauge lines
      const guageColor = ["#dc2626", "#10b981", "#dc2626"];

      // Calculate total range
      const totalRange = values[values.length - 1] - values[0];
      const observationPercentage =
        ((observationValue - values[0]) / totalRange) * 100;

      // Calculate widths for each section
      const widths = [
        ((values[1] - values[0]) / totalRange) * 100, // First red section
        ((values[2] - values[1]) / totalRange) * 100, // Green section
        ((values[3] - values[2]) / totalRange) * 100, // Last red section
      ];
      const isBetweenRange =
        values[1] <= observationValue && values[2] >= observationValue;
      const currentColor = isBetweenRange ? guageColor[1] : guageColor[0];

      var $divAnswer = $("<div></div>")
        .addClass("answer")
        .css("display", "none");
      var $divFlex = $("<div></div>")
        .addClass("d-flex w-full align-items-center bio-result-container")
        .appendTo($divAnswer);

      var $horizontalContainer = $("<div></div>")
        .addClass("d-flex")
        .appendTo($divFlex);

      $("<div></div>")
        .addClass("horizontal-line")
        .css("border-color", element.status ? currentColor : null)
        .appendTo($horizontalContainer);

      var $divW15_1 = $("<div></div>")
        .addClass("bio-marker-container")
        .appendTo($horizontalContainer);
      $("<div></div>")
        .addClass("bio-marker-name")
        .text(element.title)
        .appendTo($divW15_1);
      $("<div></div>")
        .addClass("test-status")
        .text(element.status)
        .css("background-color", currentColor)
        .appendTo($divW15_1);

      var $divW15_2 = $("<div></div>").addClass("bio-range").appendTo($divFlex);
      $("<span></span>")
        .addClass("test-value")
        .text(element["Observation Value"])
        .appendTo($divW15_2);
      $("<div></div>")
        .addClass("d-flex flex-column justify-center")
        .appendTo($divW15_2)
        .append($("<div></div>").addClass("test-unit").text(element["Units"]))
        .append(
          $("<div></div>")
            .addClass("test-range")
            .text(element["Reference Range"]),
        );

      // Create the HTML structure for the gauge meter
      var $gaugeContainer = $("<div></div>").addClass(
        "w-full d-flex flex-column p-1 gauge-container relative",
      );

      var $gaugeLines = $("<div></div>").addClass("w-full d-flex flex-row");

      // Add three gauge lines with calculated widths
      for (var i = 0; i < guageColor.length; i++) {
        $gaugeLines.append(
          $("<div></div>")
            .addClass("gauge-line")
            .css({
              "background-color": guageColor[i],
              width: `${widths[i]}%`,
            }),
        );
      }

      var $metricsContainer = $("<div></div>").addClass(
        "metrics-container d-flex w-full",
      );

      // Creating spans for metric values
      for (var i = 1; i < values.length - 1; i++) {
        var $spanContainer = $("<div></div>").addClass(
          "d-flex justify-content-between flex-1",
        );
        $spanContainer.append(
          $("<span></span>")
            .text(values[i])
            .css({
              width: `${widths[0]}%`,
              "text-align": "end",
            }),
        );
        $spanContainer.append(
          $("<span></span>")
            .text(values[i + 1])
            .css({
              width: `${widths[2]}%`,
            }),
        );
        i++;
        $metricsContainer.append($spanContainer);
      }

      var svgIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="point-icon">
    <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/>
  </svg>
`;
      // const indicatorPercentage = calculateWidthInRange(
      //   values[1],
      //   values[2],
      //   element["Observation Value"]
      // );
      var $pointIconContainer = $("<div></div>")
        .addClass("point-icon-container")
        .html(svgIcon)
        .css({
          left: `${observationPercentage}%`,
          color: currentColor,
        });

      $gaugeContainer.append($gaugeLines);
      $gaugeContainer.append($metricsContainer);
      $gaugeContainer.append($pointIconContainer);

      if (referenceRange) {
        var $divW50 = $("<div></div>")
          .addClass("w-50 gauge-container-parent")
          .appendTo($divFlex);
        $divW50.append($gaugeContainer);
      }

      liContainer.append($divAnswer);

      // Add dropdown button and container with test information
      if (testPocket && testPocket.options) {
        var $dropButton = $("<div></div>")
          .addClass("drop-button")
          .html(
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>',
          )
          .css({
            cursor: "pointer",
            marginLeft: "8px",
            transition: "transform 0.3s",
          });

        var $infoContent = $("<div></div>").addClass("info-content").css({
          display: "none",
          width: "100%",
          marginTop: "10px",
          padding: "15px",
          backgroundColor: "#f9fafb",
          borderRadius: "8px",
        });

        // Loop through options and add content
        testPocket.options.forEach((option) => {
          var $optionTitle = $("<h3></h3>").text(option.title).css({
            marginBottom: "8px",
            fontWeight: "bold",
          });

          var $optionDetails = $("<div></div>").html(option.details).css({
            fontSize: "14px",
          });

          $infoContent.append($optionTitle, $optionDetails);
        });

        $dropButton.on("click", function (e) {
          e.stopPropagation();
          var isVisible = $infoContent.is(":visible");

          $infoContent.slideToggle(function () {
            $dropButton.css(
              "transform",
              isVisible ? "rotate(0deg)" : "rotate(180deg) translateY(10px)",
            );
          });
        });

        $divFlex.append($dropButton);
        $divAnswer.append($infoContent);
      }
    };

    const newCategories = {};
    data.results.forEach((value) => {
      const [testInformation] =
        value["Test Code, Test Name, IT Source, Lab Section"];
      const testPocket = testDetails.find(
        (t) => t.test_code === testInformation,
      );
      const { categories } = testPocket || {};
      let categoryId, categoryName;
      if (categories?.length) {
        const [category] = categories;
        categoryId = category.id;
        categoryName = category.name;
      } else {
        categoryName = data.name;
        categoryId = "default";
      }

      if (!categoryId) {
        categoryName = data.name;
        categoryId = "default";
      }

      if (!newCategories[categoryId]) {
        newCategories[categoryId] = {
          results: [],
          name: categoryName,
        };
      }

      newCategories[categoryId].results.push(value);
    });

    $("#result-section").append(container);

    Object.keys(newCategories).map((key) => {
      const { results, name } = newCategories[key];

      const $ul = $("<ul></ul>").addClass("accordion-list");
      const $li = $("<li></li>").addClass("active");

      const $h3 = $("<h3></h3>").addClass("result-title");
      const icon = $("<img>").attr({
        src: "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/file.svg?v=1700320081",
        alt: "file icon",
      });
      const title = $("<span></span>").text(`${name}`);

      title.appendTo($h3);
      icon.appendTo($h3);

      results.forEach((value) => processElement(value, $li));

      $ul.append($h3);
      $ul.append($li);
      $li.find(".answer").slideDown();
      $("#result-section").append($ul);
    });

    /* --------------- Accordion js -------------------*/
    $("#result-section").on("click", ".accordion-list > li", function () {
      // console.log("accordion clicked");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active").find(".answer").slideUp();
      } else {
        $(".accordion-list > li.active .answer").slideUp();
        $(".accordion-list > li.active").removeClass("active");
        $(this).addClass("active").find(".answer").slideDown();
      }
      return false;
    });

    const iframe = document.getElementById("result-iframe");
    if (iframe) {
      // need to dynamically add src to iframe
      const url = `https://doctor.imulab.co.uk/public/test-result/${data.shopify_order_id}?name=${data.name}`;
      console.log({ iframeUrl: url });
      iframe.src = url;
    }

    /* --------------- Accordion js -------------------*/
  }

  function roundToNearest(value, higher = true) {
    if (value <= 10) {
      return higher ? 10 : 0;
    } else if (value <= 100) {
      return higher ? Math.ceil(value / 10) * 10 : Math.floor(value / 10) * 10;
    } else if (value <= 1000) {
      return higher
        ? Math.ceil(value / 100) * 100
        : Math.floor(value / 100) * 100;
    } else {
      return higher
        ? Math.ceil(value / 1000) * 1000
        : Math.floor(value / 1000) * 1000;
    }
  }

  function generateGaugeArray(range, value) {
    if (!range) return [0, 0, 1, 1];

    if (range.includes("-")) {
      const [startStr, endStr] = range.split("-");
      const start = parseFloat(startStr);
      const end = parseFloat(endStr);
      const minRounded = 0;
      let maxRounded = end + (start === 0 ? value : start);
      if (value >= maxRounded) {
        maxRounded += value;
      }
      return [minRounded, start, end, maxRounded];
    }

    if (range.includes(">")) {
      let min = parseFloat(range.substring(1).trim());
      let max = value + min;
      const minRounded = 0;
      return [minRounded, min, max, max];
    }

    if (range.includes("<")) {
      let max = parseFloat(range.substring(1).trim());
      let min = 0;
      const minRounded = 0;
      return [minRounded, min, max, max + value];
    }

    return [0, 0, 1, 1];
  }

  function handleValue(value) {
    if (!value) return 0;
    if (value.includes(">")) {
      const [_, ...rest] = value;
      return parseFloat(rest.join("")) + 1;
    } else if (value.includes("<")) {
      const [_, ...rest] = value;
      return parseFloat(rest.join("")) - 1;
    } else {
      return parseFloat(value);
    }
  }

  function calculateWidthInRange(start, end, value) {
    const totalWidth = 34;
    const range = end - start;
    const percentage = (value - start) / range;
    const position = percentage * totalWidth;
    const output = totalWidth + position;
    return isNaN(output) ? 0 : output;
  }
  $(".page-container, .page-width-desktop").css({
    display: "none",
  });
  $("#loader").show();
  fetchTestResult()
    .then(({ data: result, testDetails }) => {
      console.log("Order list received in result:", result);
      if (result.length) {
        mapTestResultsToHTML(result[0], testDetails);
      }
    })
    .catch((error) => {
      // Handle errors
      console.error("Error:", error);
    })
    .finally(() => {
      $(".page-container, .page-width-desktop").css({
        display: "block",
      });
      $("#loader").hide();
    });
});
